import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import styles from "./StaticImage.module.scss";
import { CardComponentProps } from "@~/types/types";
import { ProductLink } from "../__shared__/ProductLink/ProductLink";
import { isM2MFabricProduct } from "../__shared__/ProductLink/components/M2MProductSelector/utils";
import { Image } from "../__shared__/Image/Image";

export const StaticImage = ({
  index,
  product,
  configProps,
}: Pick<CardComponentProps, "index" | "product" | "configProps">) => {
  const { variant } = useVariant();
  const isM2MProduct = isM2MFabricProduct(product);

  const baseImgUrl = variant?.images.primary.split("?")[0] || "";

  if (!baseImgUrl) {
    return null;
  }

  const imageElement = (
    <Image
      url={baseImgUrl}
      title={product.title}
      colour={variant?.colour?.colour || ""}
      index={index}
    />
  );

  const containerClass = isM2MProduct
    ? styles.buttonContainer
    : styles.container;

  return (
    <ProductLink
      product={product}
      className={containerClass}
      componentName="StaticImage"
      tabIndex={-1}
      opensQuickView={configProps?.productLinkOpensQuickView === true}
    >
      {imageElement}
    </ProductLink>
  );
};
